import { jsx } from "react/jsx-runtime";
import React from "react";
import {
  AccessibilityUtil,
  LocaleProvider,
  createDOMProps
} from "react-native-web-internals";
const createElement = (component, props, options) => {
  let accessibilityComponent;
  if (component && component.constructor === String) {
    accessibilityComponent = AccessibilityUtil.propsToAccessibilityComponent(props);
  }
  const Component = accessibilityComponent || component;
  const domProps = createDOMProps(Component, props, options);
  const element = React.createElement(Component, domProps);
  const elementWithLocaleProvider = domProps.dir ? /* @__PURE__ */ jsx(LocaleProvider, { direction: domProps.dir, locale: domProps.lang, children: element }) : element;
  return elementWithLocaleProvider;
};
var createElement_default = createElement;
export {
  createElement_default as default
};
//# sourceMappingURL=index.js.map
